import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Destination } from '../models/destination.model';
import { ApolloService } from './apollo.service';

@Injectable({
  providedIn: 'root',
})
export class DestinationService {
  private return = `
    {
      country,
      continent,
      description,
      id,
      coverPicture {
        id,
        src,
        width,
        height
      }
    }
  `;

  constructor(private apollo: ApolloService) {}

  getDestinations(): Observable<Destination[]> {
    return this.apollo.query(`{destinations${this.return}}`, 'destinations');
  }

  getDestination(destinationId: string): Observable<Destination> {
    return this.apollo.query(
      `{destination(id: "${destinationId}")${this.return}}`,
      'destination',
      null
    );
  }

  getDestinationByCountry(country: string): Observable<Destination> {
    return this.apollo.query(
      `{destination(country: "${country}")${this.return}}`,
      'destination'
    );
  }

  createDestination(destination: Destination): Observable<Destination> {
    return this.apollo.mutate(
      `CreateDestination($destination: CreateDestinationInput!) {
            createDestination(createDestinationInput: $destination)${this.return}
          }`,
      'createDestination',
      { destination }
    );
  }

  updateDestination(destination: Destination): Observable<Destination> {
    return this.apollo.mutate(
      `UpdateDestination($destination: UpdateDestinationInput!) {
            updateDestination(updateDestinationInput: $destination)${this.return}
          }`,
      'updateDestination',
      { destination }
    );
  }

  deleteDestination(destinationId: string): Observable<boolean> {
    return this.apollo
      .mutate<number>(
        `RemoveDestination($destinationId: string!) {
                removeDestination(id: $destinationId)
            }`,
        'removeDestination',
        { destinationId }
      )
      .pipe(map((x) => x > 0));
  }
}
